import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
import { useParams } from "react-router";
import Iconify from "src/components/iconify";
import Image from "src/components/image";
import Logo from "src/components/logo";

type Translation = {
  title: string,
  step1: string,
  step2: string,
  step3: string,
  step3description: string,
  step4: string,
  step4sub1: string,
  step4sub2: string,
  step4sub3: string,
  step4sub4: string,
  step4sub5: string,
  step4sub6: string,
  step5: string,
  step5sub1: string,
  step5sub2: string,
  step5sub3: string,
  step5sub4: string,
  step5sub5: string,
  step6: string,
  step6sub1: string,
}

const TranslationsEn: Translation = {
  title: "What to do each day before you start driving:",
  step1: "1. Login into the app",
  step2: "2. Connect to the vehicle and confirm you are connected and see the green icon in the top right corner",
  step3: "3. Start the vehicle/truck",
  step3description: "Turn the engine of your Truck on",
  step4: "4. Change your status to &apos;On Duty&apos;",
  step4sub1: "- Click the Current Status Box on the homepage",
  step4sub2: "- Select the &apos;On Duty&apos; option",
  step4sub3: "- Confirm Location",
  step4sub4: "- Select the &apos;Pre-trip inspection&apos; option",
  step4sub5: "- *Make sure the note for the on duty status is Pre-trip Inspection",
  step4sub6: "- *Make sure the location is correct",
  step5: "5. Open your logs and confirm all are certified and all forms have been submitted",
  step5sub1: "- Open Sidebar",
  step5sub2: "- Select logs",
  step5sub3: "- Open each day with red signs",
  step5sub4: "- Certify the date",
  step5sub5: "- Submit the form",
  step6: "6. Navigate back to the status page and start driving!",
  step6sub1: "That is it! Open the sidebar, select status and you are ready to go!"
}

const TranslationsEs: Translation = {
  title: "Qué hacer cada día antes de empezar a conducir:",
  step1: "1. Inicia sesión en la aplicación",
  step2: "2. Conéctate al vehículo y confirma que estás conectado y ves el icono verde en la esquina superior derecha",
  step3: "3. Enciende el vehículo/camión",
  step3description: "Enciende el motor de tu camión",
  step4: "4. Cambia tu estado a &apos;En servicio&apos;",
  step4sub1: "- Haz clic en el Cuadro de Estado Actual en la página principal",
  step4sub2: "- Selecciona la opción &apos;En servicio&apos;",
  step4sub3: "- Confirma la ubicación",
  step4sub4: "- Selecciona la opción &apos;Inspección previa al viaje&apos;",
  step4sub5: "- *Asegúrate de que la nota para el estado en servicio sea Inspección previa al viaje",
  step4sub6: "- *Asegúrate de que la ubicación sea correcta",
  step5: "5. Abre tus registros y confirma que todos estén certificados y que todos los formularios hayan sido enviados",
  step5sub1: "- Abre la barra lateral",
  step5sub2: "- Selecciona registros",
  step5sub3: "- Abre cada día con señales rojas",
  step5sub4: "- Certifica la fecha",
  step5sub5: "- Envía el formulario",
  step6: "6. Regresa a la página de estado y ¡comienza a conducir!",
  step6sub1: "¡Eso es todo! Abre la barra lateral, selecciona estado y estás listo para comenzar!"
}


export default function HowToUseDriver() {
  const {lang} = useParams();
  const translation: Translation = lang === "es" ? TranslationsEs : TranslationsEn;

  return <Box display="flex" flexDirection="column" p={4} alignItems="center" justifyContent="center">
      <Logo dark />
      <h1>{translation.title}</h1>
      <Box>
        <Accordion>
          <AccordionSummary
            expandIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <h3>{translation.step1}</h3>
          </AccordionSummary>
          <AccordionDetails>
            <Image src="https://accountingimageuploads.s3.us-west-2.amazonaws.com/1.png" sx={{maxWidth: "400px", display: "block"}} />
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <h3>{translation.step2}</h3>
          </AccordionSummary>
          <AccordionDetails>
            <Image src="https://accountingimageuploads.s3.us-west-2.amazonaws.com/2.png" sx={{maxWidth: "400px", display: "block"}} />
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <h3>{translation.step3}</h3>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              {translation.step3description}
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <h3>{translation.step4}</h3>
          </AccordionSummary>
          <AccordionDetails sx={{fontWeight: 500}}>
            <Box pb={1}>
              {translation.step4sub1}
            </Box>
            <Image src="https://accountingimageuploads.s3.us-west-2.amazonaws.com/3.png" sx={{maxWidth: "400px", display: "block"}} />
            <br/>
            <Box pb={1}>
              {translation.step4sub2}<br/>
              {translation.step4sub3}<br/>
              {translation.step4sub4}<br/>
            </Box>
            <Image src="https://accountingimageuploads.s3.us-west-2.amazonaws.com/4.png" sx={{maxWidth: "400px", display: "block"}} />
            <Typography>
              {translation.step4sub5}
              <br />
              {translation.step4sub6}
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <h3>{translation.step5}</h3>
          </AccordionSummary>
          <AccordionDetails sx={{fontWeight: 500}}>
            <Box pb={1}>
              {translation.step5sub1}
            </Box>
            <Image src="https://accountingimageuploads.s3.us-west-2.amazonaws.com/5.jpg" sx={{maxWidth: "400px", display: "block"}} />
            <Box pt={4} pb={1}>
              {translation.step5sub2}
            </Box>
            <Image src="https://accountingimageuploads.s3.us-west-2.amazonaws.com/6.png" sx={{maxWidth: "220px", display: "block"}} />
            <Box pt={4} pb={1}>
              {translation.step5sub3}
            </Box>
            <Image src="https://accountingimageuploads.s3.us-west-2.amazonaws.com/7.png" sx={{maxWidth: "400px", display: "block"}} />
            <Box pt={4} pb={1}>
              {translation.step5sub4}
            </Box>
            <Image src="https://accountingimageuploads.s3.us-west-2.amazonaws.com/8.png" sx={{maxWidth: "400px", display: "block"}} />
            <Box pt={4} pb={1}>
              {translation.step5sub5}
            </Box>
            <Image src="https://accountingimageuploads.s3.us-west-2.amazonaws.com/9.png" sx={{maxWidth: "400px", display: "block"}} />
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <h3>{translation.step6}</h3>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              {translation.step6sub1}
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>
  </Box>;
}